export const COOKIE_KEY_PLAN_TAG = 'planTag';
export const COOKIE_KEY_SELECTED_OFFER_ID = 'selectedOfferId';
export const COOKIE_KEY_IS_EXPERIMENT_PLAN_TAG = 'isExperimentPlanTag';



// WEBPACK FOOTER //
// ./src/constants/cookies.js